import { render, staticRenderFns } from "./glassSizePOPopover.vue?vue&type=template&id=2c4a8c38&scoped=true&"
import script from "./glassSizePOPopover.vue?vue&type=script&lang=js&"
export * from "./glassSizePOPopover.vue?vue&type=script&lang=js&"
import style0 from "./glassSizePOPopover.vue?vue&type=style&index=0&id=2c4a8c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a8c38",
  null
  
)

export default component.exports